// extracted by mini-css-extract-plugin
export var messageSideLeft = "_op-1";
export var messageSideRight = "_op-2";
export var subscribeToBackInStockBubbleContainer = "_op-0";